import Button from 'common/components/button'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { ArrowRight as ArrowRightIcon } from 'common/icons'
import useUpdateElementsMutation from 'features/unifiedFlow/api/mutations/useUpdateElementsMutation'
import { getSelectedElement } from 'features/unifiedFlow/contentPage/helpers'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'
import {
  MAX_TEMPLATES_TO_ADD,
  postAddTemplate,
} from 'features/unifiedFlow/store/unifiedFlowSlice'

const TemplatesToAddBar = () => {
  const dispatch = useAppDispatch()
  const updateElementsMutation = useUpdateElementsMutation()

  const { content } = useContent()
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const activeContentId = content?._id

  const templatesToAdd = useAppSelector(
    (state) => state.unifiedFlow.templatesToAdd
  )
  const templatesToAddCount = templatesToAdd.reduce(
    (acc, template) => acc + template.count,
    0
  )

  const handleAddTemplates = () => {
    if (activeContentId) {
      updateElementsMutation.mutate(
        {
          accountId,
          contentId: activeContentId,
          templates: templatesToAdd,
        },
        {
          onSuccess: (updatedContent) => {
            const selectedElement = getSelectedElement(updatedContent)
            dispatch(
              postAddTemplate({
                selectedElementId: selectedElement?.element_id,
              })
            )
          },
        }
      )
    }
  }

  const alreadyAddedTemplatesCount = content?.elements.length
    ? content.elements.length - 1
    : 0
  const selectedText = `${templatesToAddCount} of ${
    MAX_TEMPLATES_TO_ADD - alreadyAddedTemplatesCount
  } selected`
  const isCtaDisabled = templatesToAddCount === 0

  return (
    <div className="flex items-center my-2 p-6 w-full">
      <div className="text-coolGray-800 font-medium text-xl">
        {selectedText}
      </div>
      <Button
        data-cy="add-templates-button"
        className="ml-auto"
        disabled={isCtaDisabled}
        variant="primary"
        suffixIcon={<ArrowRightIcon isDefaultColor={false} size={4} />}
        onClick={handleAddTemplates}
      >
        Next
      </Button>
    </div>
  )
}

export default TemplatesToAddBar
